/**
 * CATALOGO DE DEMOSTRACION
 * ------------------------
 * Grupo Aceros Lima vive de los servicios de transformacion (corte laser,
 * oxicorte, plegado y rolado) y ademas vende dos familias de material:
 * planchas metalicas y ejes redondos solidos.
 *
 * Estos datos se usan mientras no haya credenciales de Firebase (o mientras la
 * coleccion "productos" este vacia), para que la web se pueda ver y probar de
 * punta a punta desde el primer minuto.
 *
 * Las medidas y normas son valores estandar de catalogo siderurgico. Los
 * PRECIOS son referenciales y NO corresponden a la lista real de la empresa:
 * hay que reemplazarlos desde /admin antes de publicar. Cada registro lleva
 * `demo: true` para que la interfaz avise de ello.
 *
 * PENDIENTE: confirmar con el cliente que espesores, calidades y diametros
 * maneja realmente en stock.
 */

export const CATEGORIAS_DEMO = [
  {
    id: "planchas",
    nombre: "Planchas metalicas",
    slug: "planchas",
    resumen:
      "Plancha laminada en caliente y en frio, galvanizada, estriada e inoxidable.",
    orden: 1,
  },
  {
    id: "ejes",
    nombre: "Ejes redondos solidos",
    slug: "ejes",
    resumen: "Barra redonda lisa maciza para ejes, pines y piezas torneadas.",
    orden: 2,
  },
];

/** unidad: como se vende y como se cotiza cada item. */
export const PRODUCTOS_DEMO = [
  // ---------------- Planchas metalicas ----------------
  {
    id: "plancha-lac-3-16",
    sku: "PL-LAC-316",
    nombre: 'Plancha LAC 3/16" x 1.20 x 2.40 m',
    categoria: "planchas",
    descripcion:
      "Plancha laminada en caliente para estructuras, bases y piezas que luego se cortan o pliegan.",
    especificaciones: {
      norma: "ASTM A36",
      espesor: '3/16" (4.5 mm)',
      medida: "1.20 x 2.40 m",
      pesoUnitario: 101.7,
      acabado: "Negro",
    },
    unidad: "plancha",
    precio: 520.0,
    stock: 45,
    destacado: true,
    activo: true,
    orden: 1,
    demo: true,
  },
  {
    id: "plancha-lac-1-4",
    sku: "PL-LAC-14",
    nombre: 'Plancha LAC 1/4" x 1.20 x 2.40 m',
    categoria: "planchas",
    descripcion:
      "Espesor de uso frecuente en bases de columna, refuerzos y piezas cortadas por oxicorte.",
    especificaciones: {
      norma: "ASTM A36",
      espesor: '1/4" (6.0 mm)',
      medida: "1.20 x 2.40 m",
      pesoUnitario: 135.6,
      acabado: "Negro",
    },
    unidad: "plancha",
    precio: 690.0,
    stock: 32,
    destacado: true,
    activo: true,
    orden: 2,
    demo: true,
  },
  {
    id: "plancha-lac-1-2",
    sku: "PL-LAC-12",
    nombre: 'Plancha LAC 1/2" x 1.20 x 2.40 m',
    categoria: "planchas",
    descripcion:
      "Espesor grueso para piezas estructurales y de desgaste. Se dimensiona por oxicorte.",
    especificaciones: {
      norma: "ASTM A36",
      espesor: '1/2" (12.0 mm)',
      medida: "1.20 x 2.40 m",
      pesoUnitario: 271.2,
      acabado: "Negro",
    },
    unidad: "plancha",
    precio: 1380.0,
    stock: 14,
    destacado: false,
    activo: true,
    orden: 3,
    demo: true,
  },
  {
    id: "plancha-laf-1-5",
    sku: "PL-LAF-150",
    nombre: "Plancha LAF 1.50 mm x 1.20 x 2.40 m",
    categoria: "planchas",
    descripcion:
      "Laminada en frio, superficie lisa y tolerancia fina. Ideal para plegado y piezas a la vista.",
    especificaciones: {
      norma: "ASTM A1008",
      espesor: "1.50 mm",
      medida: "1.20 x 2.40 m",
      pesoUnitario: 33.9,
      acabado: "Laminado en frio",
    },
    unidad: "plancha",
    precio: 195.0,
    stock: 90,
    destacado: true,
    activo: true,
    orden: 4,
    demo: true,
  },
  {
    id: "plancha-galvanizada-0-9",
    sku: "PL-GALV-090",
    nombre: "Plancha galvanizada 0.90 mm x 1.20 x 2.40 m",
    categoria: "planchas",
    descripcion:
      "Recubrimiento de zinc para ductos, gabinetes y piezas expuestas a la intemperie.",
    especificaciones: {
      norma: "ASTM A653",
      espesor: "0.90 mm",
      medida: "1.20 x 2.40 m",
      pesoUnitario: 20.3,
      acabado: "Galvanizado Z90",
    },
    unidad: "plancha",
    precio: 148.0,
    stock: 120,
    destacado: false,
    activo: true,
    orden: 5,
    demo: true,
  },
  {
    id: "plancha-estriada-1-8",
    sku: "PL-EST-18",
    nombre: 'Plancha estriada 1/8" x 1.20 x 2.40 m',
    categoria: "planchas",
    descripcion:
      "Superficie antideslizante para escaleras, plataformas y pisos industriales.",
    especificaciones: {
      norma: "ASTM A36",
      espesor: '1/8" (3.0 mm)',
      medida: "1.20 x 2.40 m",
      pesoUnitario: 72.4,
      acabado: "Estriado lagrima",
    },
    unidad: "plancha",
    precio: 395.0,
    stock: 38,
    destacado: false,
    activo: true,
    orden: 6,
    demo: true,
  },
  {
    id: "plancha-inox-304-2mm",
    sku: "PL-INOX-304-20",
    nombre: "Plancha inoxidable 304 2.00 mm x 1.22 x 2.44 m",
    categoria: "planchas",
    descripcion:
      "Acero inoxidable AISI 304 para industria alimentaria, mobiliario y ambientes corrosivos.",
    especificaciones: {
      norma: "AISI 304 / ASTM A240",
      espesor: "2.00 mm",
      medida: "1.22 x 2.44 m",
      pesoUnitario: 47.6,
      acabado: "2B",
    },
    unidad: "plancha",
    precio: 1250.0,
    stock: 12,
    destacado: false,
    activo: true,
    orden: 7,
    demo: true,
  },

  // ---------------- Ejes redondos solidos ----------------
  {
    id: "eje-1045-1",
    sku: "EJ-1045-100",
    nombre: 'Eje redondo solido 1" x 6 m',
    categoria: "ejes",
    descripcion:
      "Barra redonda lisa maciza para ejes, pines, bocinas y piezas torneadas.",
    especificaciones: {
      norma: "SAE 1045",
      diametro: '1" (25.4 mm)',
      largo: "6 m",
      pesoUnitario: 23.8,
      acabado: "Laminado en caliente",
    },
    unidad: "barra",
    precio: 210.0,
    stock: 40,
    destacado: true,
    activo: true,
    orden: 1,
    demo: true,
  },
  {
    id: "eje-1045-1-1-2",
    sku: "EJ-1045-150",
    nombre: 'Eje redondo solido 1 1/2" x 6 m',
    categoria: "ejes",
    descripcion:
      "Diametro intermedio para ejes de transmision y componentes mecanizados.",
    especificaciones: {
      norma: "SAE 1045",
      diametro: '1 1/2" (38.1 mm)',
      largo: "6 m",
      pesoUnitario: 53.6,
      acabado: "Laminado en caliente",
    },
    unidad: "barra",
    precio: 470.0,
    stock: 26,
    destacado: false,
    activo: true,
    orden: 2,
    demo: true,
  },
  {
    id: "eje-1045-2",
    sku: "EJ-1045-200",
    nombre: 'Eje redondo solido 2" x 6 m',
    categoria: "ejes",
    descripcion:
      "Para ejes de mayor carga, rodillos y piezas que se mecanizan a medida.",
    especificaciones: {
      norma: "SAE 1045",
      diametro: '2" (50.8 mm)',
      largo: "6 m",
      pesoUnitario: 95.3,
      acabado: "Laminado en caliente",
    },
    unidad: "barra",
    precio: 830.0,
    stock: 18,
    destacado: true,
    activo: true,
    orden: 3,
    demo: true,
  },
  {
    id: "eje-1020-3-4",
    sku: "EJ-1020-075",
    nombre: 'Eje redondo solido 3/4" x 6 m',
    categoria: "ejes",
    descripcion:
      "Acero de bajo carbono, facil de soldar y mecanizar, para piezas de uso general.",
    especificaciones: {
      norma: "SAE 1020",
      diametro: '3/4" (19.1 mm)',
      largo: "6 m",
      pesoUnitario: 13.4,
      acabado: "Laminado en caliente",
    },
    unidad: "barra",
    precio: 118.0,
    stock: 55,
    destacado: false,
    activo: true,
    orden: 4,
    demo: true,
  },
  {
    id: "eje-inox-304-1",
    sku: "EJ-INOX-304-100",
    nombre: 'Eje redondo inoxidable 304 1" x 6 m',
    categoria: "ejes",
    descripcion:
      "Barra redonda de acero inoxidable para ejes en ambientes humedos o corrosivos.",
    especificaciones: {
      norma: "AISI 304",
      diametro: '1" (25.4 mm)',
      largo: "6 m",
      pesoUnitario: 24.2,
      acabado: "Laminado",
    },
    unidad: "barra",
    precio: 980.0,
    stock: 8,
    destacado: false,
    activo: true,
    orden: 5,
    demo: true,
  },
];

/**
 * Servicios: el nucleo del negocio.
 * PENDIENTE: capacidades reales (espesor maximo por proceso, largo util de
 * mesa y de plegadora, diametros de rolado). No se inventan aqui.
 */
export const SERVICIOS_DEMO = [
  {
    id: "corte-laser",
    nombre: "Corte laser",
    resumen:
      "Cortes limpios y de alta precision en plancha, siguiendo tu archivo DXF.",
    detalle:
      "Ideal para piezas con detalle fino, perforaciones y contornos complejos. El borde sale listo para soldar o pintar, sin rebaba que rectificar.",
    orden: 1,
  },
  {
    id: "oxicorte",
    nombre: "Oxicorte",
    resumen: "Corte de planchas gruesas donde el laser ya no llega.",
    detalle:
      "Proceso indicado para espesores altos en acero al carbono: bases de columna, placas de anclaje y piezas estructurales pesadas.",
    orden: 2,
  },
  {
    id: "plegado",
    nombre: "Plegado",
    resumen: "Doblamos la plancha segun tu plano, angulo por angulo.",
    detalle:
      "Prensa plegadora hidraulica con control numerico. Entregamos la pieza formada: perfiles, canales, gabinetes, tapas y bandejas.",
    orden: 3,
  },
  {
    id: "rolado",
    nombre: "Rolado",
    resumen: "Curvamos plancha para cilindros, conos y virolas.",
    detalle:
      "Para tanques, ductos, silos y cualquier pieza que necesite radio constante. El diametro se define contigo antes de rolar.",
    orden: 4,
  },
];
